<template lang="pug">
.header-container(
  :class='[{ active: active }]',
  :style='{ background: background, height: height }'
)
  .left(:style="`flex:${leftFlex}`")
    img.back(:src='leftIcon', @click='goBack')
    slot(name="left" v-if="showLeftSlot()")
    slot(name="left-noscroll"   v-else-if="showLeftNoScrollSlot()")
  .title.mid(:style='{ color,flex: middleFlex }')
    slot(name="middle")
  .right(:style="`flex:${rightFlex}`")
    slot(name='right')
</template>

<script>
import { env, Native } from '@hb/NBridge/lib/h5';
import { BLACK_LEFT_ICON, WHITE_LEFT_ICON } from '@/const';

export default {
  props: {
    title: {
      type: String,
      default: document.title,
    },
    activeTitle: {
      type: String,
      default: document.title,
    },
    activeColor: {
      type: String,
      default: 'black',
    },
    activeThreshold: {
      type: Number,
      default: 20,
    },
    inactiveColor: {
      type: String,
      default: 'black',
    },
    leftBlackWhenActive: {
      type: Boolean,
      default: true,
    },
    leftBlackWhenInactive: {
      type: Boolean,
      default: true,
    },
    leftFlex: {
      type: Number,
      default: null,
    },
    rightFlex: {
      type: Number,
      default: 0.5,
    },
    // 箭头图片
    leftBalckColor: {
      type: String,
      default: null,
    },
    isBackClose: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: '255,255,255',
    },
    height: {
      type: String,
      default: '0.84rem',
    },
    middleFlex: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      scrollTop: 0,
    };
  },
  computed: {
    active() {
      return this.scrollTop > this.activeThreshold * 0.75;
    },
    color() {
      if (this.active) {
        return this.activeColor;
      }
      return this.inactiveColor;
    },
    leftIcon() {
      if (this.leftBalckColor) {
        return this.leftBalckColor;
      }
      if (this.active) {
        if (this.leftBlackWhenActive) {
          return BLACK_LEFT_ICON;
        }
        return WHITE_LEFT_ICON;
      }
      if (this.leftBlackWhenInactive) {
        return BLACK_LEFT_ICON;
      }
      return WHITE_LEFT_ICON;
    },
    background() {
      return `rgba(${this.backgroundColor}, ${Math.min(20, this.scrollTop)
        / this.activeThreshold})`;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handler);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handler);
  },
  methods: {
    goBack() {
      if (this.isBackClose) {
        Native.closeWebView();
      } else if (env.isEasyBikeApp) {
        Native.goBack();
      } else {
        this.$router.go(-1);
      }
    },
    handler() {
      const scrolltop = document.documentElement.scrollTop
        || window.pageYOffset
        || document.body.scrollTop;
      this.scrollTop = scrolltop;
    },
    showSlot() {
      return (Math.min(20, this.scrollTop) / this.activeThreshold < 0.5);
    },
    showLeftSlot() {
      // 有 left-noscroll 插槽且 num < 0.5 或者没有 left-noscroll 插槽
      return (this.$slots['left-noscroll'] && (Math.min(20, this.scrollTop) / this.activeThreshold < 0.5)) || !this.$slots['left-noscroll'];
    },
    showLeftNoScrollSlot() {
      // 有 left-noscroll 插槽且 num >= 0.5
      return this.$slots['left-noscroll'] && (Math.min(20, this.scrollTop) / this.activeThreshold) >= 0.5;
    },
  },
};
</script>

<style lang="less" scoped>
.header-container {
  padding: 0.4rem 0.1rem 0;
  width: 100vw;
  height: 0.84rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 50 !important;
  transition: background 0.3s ease;
  background-color: transparent;

  .back {
    width: 0.24rem;
    height: 0.24rem;
  }

  .left {
    display: flex;
    text-align: left;
  }

  .mid {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }

  .title {
    font-size: 0.18rem;
    font-weight: 500;
  }

  .right {
    flex: 0.5;
    text-align: right;
  }
}
</style>
